export default class Modal {
  show(modalElement) {
    $(modalElement).modal('show');
  }

  hide(modalElement) {
    $(modalElement).modal('hide');
  }
}
